import type { Game } from 'chessboard/model/game/types';
import type { API } from 'chessboard/api/config/types';

/**
 * Create the getNodeIds() method
 */
export function createGetNodeIds(context: API.Context) {
  /**
   * Get next color to move.
   */
  return function getNodeIds(): Game.Node.Model {
    const { game } = context;

    return game.ids();
  };
}
